async function getCameraDevices () {
  let devices = await navigator.mediaDevices.enumerateDevices()
  devices = devices.filter((o) => (o.kind === 'videoinput'))
  return devices
}

export {
  getCameraDevices
}
